import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import useAuthProfile from 'shared/features/auth/authentication/providers/states/auth-profile';
import Permission from 'shared/features/auth/authorization/enums/permission';
import usePermissionAuthorization from 'shared/features/auth/authorization/hooks/permission-authorization';
import { useGetVcareConnectorExistsQuery } from 'shared/providers/connector/domain/queries/vcare-connector-queries';

export interface IConnectorHook {
  hasVcareConnector: boolean;
  isLoading: boolean;
}

const useConnector = (): IConnectorHook => {
  const { isAuthenticated } = useAuth();
  const { tenant } = useAuthProfile();
  const { hasPermission } = usePermissionAuthorization();

  const canFetch = isAuthenticated && hasPermission(Permission.CareConnectReadAndUpdateSettings);

  const { data, refetch, isLoading } = useGetVcareConnectorExistsQuery(canFetch);

  useEffect(() => {
    if (canFetch) {
      refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenant.switchActivated]);

  return {
    hasVcareConnector: data ?? false,
    isLoading: isLoading && canFetch,
  };
};

export default useConnector;
